import { PropsWithChildren, ReactElement } from "react";

import { COLLAPSE_CONTAINER_MAX_HEIGHT } from "@ryde/shared";

import { CollapsableContainer } from "./collapsable-container";

interface ICollapsableControlContainerProps extends PropsWithChildren {
  maxHeight?: number;
  isSkipMaxHeight?: boolean;
  isCollapsed: boolean;
}

export const CollapsableControlContainer = ({
  children,
  maxHeight = COLLAPSE_CONTAINER_MAX_HEIGHT,
  isSkipMaxHeight,
  isCollapsed,
}: ICollapsableControlContainerProps): ReactElement => {
  return (
    <>
      {!isSkipMaxHeight && isCollapsed && (
        <CollapsableContainer maxHeight={maxHeight} isCollapsed={isCollapsed}>
          {children}
        </CollapsableContainer>
      )}
      {isSkipMaxHeight && (
        <CollapsableContainer
          maxHeight={maxHeight}
          isCollapsed={isCollapsed}
          isSkipMaxHeight={isSkipMaxHeight}
        >
          {children}
        </CollapsableContainer>
      )}
    </>
  );
};
